import { Component, inject } from "@angular/core";
import { TicketsInfoCardComponent } from "./tickets-info-card/tickets-info-card.component";
import { BehaviorSubject, switchMap } from "rxjs";
import { CommonModule } from "@angular/common";
import { TicketsService } from "../../../../../services/tickets.service";

@Component({
    selector: "app-tickets-info-page",
    imports: [TicketsInfoCardComponent, CommonModule],
    templateUrl: "./tickets-info-page.component.html",
    styleUrl: "./tickets-info-page.component.scss"
})
export class TicketsInfoPageComponent {
  private readonly _ticketsService = inject(TicketsService);

  selectedInterval$ = new BehaviorSubject("M");

  ticketsInfo$ = this.selectedInterval$.pipe(
    switchMap((interval) => this._ticketsService.getTicketsInfo(interval)),
  );

  handleIntervalChange(interval: string) {
    this.selectedInterval$.next(interval);
  }
}
